import React, { useEffect } from 'react'
import { Trans } from 'react-i18next'
import { useLocation } from 'react-router-dom'
import { useBoolean } from 'react-use'
import base64 from 'base-64'

import { OAuthDBPluginAPI } from '@makyoapp/makyo-sdk/api/Plugin-OAuthDB'

import { useReqError } from '../hooks/useReqError'

export function SpreadSheetAuth() {
  const location = useLocation()
  const [done, setDone] = useBoolean(false)
  const printAPIError = useReqError()
  useEffect(() => {
    const search = location.search
    const searchParam = new URLSearchParams(search)
    const stt = searchParam.get('state')
    const code = searchParam.get('code')

    if (stt && code) {
      const state = JSON.parse(base64.decode(stt))
      if (state.PluginID) {
        const pathname = window.location.pathname
        const location = `${window.location.protocol}//${window.location.host}${window.location.pathname}`
        OAuthDBPluginAPI.ReqAuth(state.PluginID, {
          Ref: state.Ref,
          Code: code,
          RedirectURI: location,
        })
          .then((res) => {
            setDone(true)
            window.close()
          })
          .catch(printAPIError)
      }
    }
    //
  }, [location.search, printAPIError])
  return (
    <div className='w-full h-full'>
      <div className='flex-cc w-full h-full'>
        {done ? (
          <>Authentication Done! You can safely close this window</>
        ) : (
          <>
            <span className='loading spin' />
            <Trans>Requesting authentication</Trans>
          </>
        )}
      </div>
    </div>
  )
}
